export default {
    id: 'blue-yellow-red',
    colors: ['#1B6DD1', '#FAAF1A', '#F23630'],
};
